import { render } from "./MultipleResponse.vue?vue&type=template&id=881dc9b8&scoped=true"
import script from "./MultipleResponse.vue?vue&type=script&lang=js"
export * from "./MultipleResponse.vue?vue&type=script&lang=js"

import "./MultipleResponse.vue?vue&type=style&index=0&id=881dc9b8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-881dc9b8"]])

export default __exports__